import React from "react";
import { ArrowUpRight } from "lucide-react";

const ReferenceCard = ({ name, href, logo, darkLogo, preview = false }) => {
  const Tag = preview ? "div" : "a";

  return (
    <Tag
      {...(!preview && { href, target: "_blank", rel: "noopener noreferrer" })}
      className="reference-card"
    >
      <div
        className="reference-card__logo"
        style={{ background: darkLogo ? "#111827" : "#fff" }}
      >
        <img
          src={`/images/references/${logo}`}
          alt=""
          width="184"
          height="64"
          loading="lazy"
          decoding="async"
        />
      </div>
      <div className="reference-card__name">
        <span>{name}</span>
        {!preview && <ArrowUpRight size={14} aria-hidden="true" />}
      </div>
    </Tag>
  );
};

export default ReferenceCard;
